/**
 * 路由映射配置
 */

export const ROUTE_MAP: Record<string, string> = {
    'dashboard': '/',
    'sku-management': '/sku-management',
    'operation-strategy': '/operation-strategy',
    'shipping-management': '/shipping-management',
    'exchange-rate': '/exchange-rate/dashboard',
    'brand-management': '/brand-management',
    'data-management': '/data-management',
    'analysis': '/analysis',
    'aba-analysis': '/aba-analysis',
    'data-check': '/data-check',
    'config-manager': '/config-manager',
    'prompt-management': '/prompt-management',
    'metrics-guide': '/metrics-guide',
    'organization': '/organization',
    'marketing-management': '/marketing/influencers',
    'store-management': '/supply-chain/stores',
    'procurement-suppliers': '/supply-chain/procurement/suppliers',
    'procurement-orders': '/supply-chain/procurement/orders',
    'logistics': '/supply-chain/logistics',
    'sku-mapping': '/supply-chain/sku-mapping',
    'order-list': '/supply-chain/orders',
    'fba-inventory': '/supply-chain/inventory',
    'data-center': '/data-analysis/center',
    'admin-statistics': '/administration?tab=statistics',
    'admin-dept-kpi': '/administration?tab=dept-kpi',
    'admin-target': '/administration?tab=target',
    'admin-assessment': '/administration?tab=assessment',
    'finance-dashboard': '/finance/dashboard',
    'finance-cost-config': '/finance/cost-config',
};

// 路由前缀到菜单key的映射
const PREFIX_MAP: Record<string, string> = {
    '/sku-management': 'sku-management',
    '/shipping-management': 'shipping-management',
    '/exchange-rate': 'exchange-rate',
    '/operation-strategy': 'operation-strategy',
    '/brand-management': 'brand-management',
    '/data-management': 'data-management',
    '/analysis': 'analysis',
    '/aba-analysis': 'aba-analysis',
    '/skus': 'analysis',
    '/data-check': 'data-check',
    '/config-manager': 'config-manager',
    '/metrics-guide': 'metrics-guide',
    '/organization': 'organization',
    '/marketing': 'marketing-management',
    '/supply-chain/stores': 'store-management',
    '/supply-chain/procurement/suppliers': 'procurement-suppliers',
    '/supply-chain/procurement/orders': 'procurement-orders',
    '/supply-chain/logistics': 'logistics',
    '/supply-chain/sku-mapping': 'sku-mapping',
    '/supply-chain/orders': 'order-list',
    '/supply-chain/inventory': 'fba-inventory',
    '/data-analysis': 'data-center',
    '/administration': 'admin-statistics',
    '/finance/dashboard': 'finance-dashboard',
    '/finance/cost-config': 'finance-cost-config',
};

/**
 * 获取选中菜单项
 */
export const getSelectedKey = (pathname: string, search?: string): string => {
    if (pathname === '/' || pathname === '/dashboard') return 'dashboard';

    // 处理行政管理的 tab 参数
    if (pathname.startsWith('/administration') && search) {
        const params = new URLSearchParams(search);
        const tab = params.get('tab');
        if (tab === 'dept-kpi') return 'admin-dept-kpi';
        if (tab === 'target') return 'admin-target';
        if (tab === 'assessment') return 'admin-assessment';
        return 'admin-statistics';
    }

    for (const [prefix, key] of Object.entries(PREFIX_MAP)) {
        if (pathname.startsWith(prefix)) return key;
    }

    return 'analysis';
};
